/* Maison Batu — Phase III · Laufzeit
   Zusammengesetzt aus timeline.js (Lampen), ball.js (Ball) und sequence.js
   (Gesamtsequenz) der freigegebenen Vorschau. Die Prüfschalter und die
   URL-Parameter der Vorschau sind entfernt.

   Gestartet wird einmalig beim Eintritt in den Viewport. Bei reduzierter
   Bewegung wird direkt der Endzustand dargestellt. */
(() => {
  "use strict";
  const roots = document.querySelectorAll("[data-mbe-root]");
  roots.forEach((root) => {
    if (root.dataset.mbeReady === "1") return;
    root.dataset.mbeReady = "1";
    initSection(root);
  });

  function initSection(root) {
    /* Portrait-Tablets use the dedicated tall master too.  The previous
       760px cut-off forced a shallow 16:9 stage at 768px and clipped cards. */
    const frameQuery = window.matchMedia("(max-width: 900px) and (orientation: portrait)");
    const syncFrame = () => {
      const nextFrame = frameQuery.matches ? "mobile" : "desktop";
      if (root.dataset.frame === nextFrame) return;
      root.dataset.frame = nextFrame;
      const sequence = window.MaisonBatuPhaseE;
      if (sequence && root.dataset.seq === "done") sequence.render(sequence.duration);
    };
    syncFrame();
    if (typeof frameQuery.addEventListener === "function") {
      frameQuery.addEventListener("change", syncFrame);
    } else if (typeof frameQuery.addListener === "function") {
      frameQuery.addListener(syncFrame);
    }

    /* ══════════════════════════════════════════════════════════════════════════
       Maison Batu — Phase III · Phase C
       Übergang Tag → Nacht und Anlaufen der sechs realen Flutlichtmasten.

       Grundsatz: animiert wird ausschließlich Deckkraft. Es wird keine Position,
       keine Größe und kein Bildausschnitt angefasst — die Hintergrundgeometrie
       kann sich dadurch gar nicht verschieben. Der Endzustand ist per
       Konstruktion identisch mit dem freigegebenen Nacht-Still.

       Kein Ball. Phase D ist bewusst noch nicht enthalten.
       ══════════════════════════════════════════════════════════════════════════ */
    (() => {
      "use strict";

      const body = root;
      const $  = (s, r = root) => r.querySelector(s);
      const $$ = (s, r = root) => Array.from(r.querySelectorAll(s));
      const scene = $(".mbe-window");
      if (!scene) return;

      /* ── Zeitplan ───────────────────────────────────────────────────────────
         Die Masten laufen bewusst nicht gleichzeitig an: vorne zuerst, hinten
         zuletzt, mit ungleichen Abständen. Jeder Mast durchläuft drei kurze
         Teilzustände mit Einbrüchen dazwischen, bevor er stabil steht — das
         Verhalten echter Metallhalogenstrahler.                              */

      const T_END        = 6.0;   // Gesamtdauer der Sequenz in Sekunden
      const NIGHT_FROM   = 0.40;  // Beginn des Übergangs Tag → Nacht
      const NIGHT_TO     = 2.45;  // Nacht vollständig erreicht

      // Startzeit und leichte individuelle Abweichung je Mast
      const IGNITION = {
        m1: { start: 2.42, scale: 1.00 },   // vorne links
        m6: { start: 2.68, scale: 0.94 },   // vorne rechts
        m2: { start: 3.09, scale: 1.07 },   // Mitte links
        m5: { start: 3.34, scale: 0.97 },   // Mitte rechts
        m3: { start: 3.71, scale: 1.12 },   // hinten links
        m4: { start: 3.93, scale: 1.03 },   // hinten rechts
        // Mobile benutzt dieselbe Kurve unter den dortigen Kennungen
        l1: { start: 2.42, scale: 1.00 },
        r1: { start: 2.68, scale: 0.94 },
        l2: { start: 3.09, scale: 1.07 },
        r2: { start: 3.34, scale: 0.97 },
        l3: { start: 3.71, scale: 1.12 },
        r3: { start: 3.93, scale: 1.03 },
      };

      /* Verlauf eines einzelnen Mastes, relativ zu seiner Startzeit.
         Drei Teilzustände (0,44 · 0,70 · 0,58) mit Einbrüchen dazwischen —
         das Briefing verlangt mindestens zwei. */
      const CURVE = [
        [0.00, 0.00],
        [0.09, 0.44],
        [0.17, 0.07],
        [0.33, 0.70],
        [0.43, 0.16],
        [0.61, 0.58],
        [0.75, 0.28],
        [1.04, 1.00],
      ];

      const clamp01 = (v) => (v < 0 ? 0 : v > 1 ? 1 : v);
      const smooth  = (v) => { const x = clamp01(v); return x * x * (3 - 2 * x); };

      function curveAt(local) {
        if (local <= 0) return 0;
        const last = CURVE[CURVE.length - 1];
        if (local >= last[0]) return last[1];
        for (let i = 1; i < CURVE.length; i++) {
          const a = CURVE[i - 1], b = CURVE[i];
          if (local <= b[0]) {
            const t = (local - a[0]) / (b[0] - a[0]);
            return a[1] + (b[1] - a[1]) * t;
          }
        }
        return last[1];
      }

      const lampEls = () => $$(".mbe-lamp");

      /* ── Einen Zeitpunkt darstellen ─────────────────────────────────────── */

      function render(t) {
        const time = Math.max(0, Math.min(T_END, t));

        const night = smooth((time - NIGHT_FROM) / (NIGHT_TO - NIGHT_FROM));
        scene.style.setProperty("--night", night.toFixed(4));

        for (const el of lampEls()) {
          const id = el.dataset.lampLayer;
          const cfg = IGNITION[id];
          // Über den Prüfschalter abgeschaltete Masten bleiben aus.
          if (!cfg || el.hasAttribute("data-off")) { el.style.setProperty("--lamp", "0"); continue; }
          const local = (time - cfg.start) / cfg.scale;
          el.style.setProperty("--lamp", curveAt(local).toFixed(4));
        }

        /* In der lokalen Pruefvorschau gab es ein separates Zeit-Readout.
           In Shopify besitzt das Bildfeld selbst nach der Zeile darueber
           data-anim-time. Der alte Selektor traf deshalb das Bildfeld und
           textContent entfernte alle Bild-, Titel-, Ball- und Kartenknoten. */
        const out = $("[data-anim-readout]");
        if (out) out.textContent = `${time.toFixed(2)} s / ${T_END.toFixed(2)} s`;
        scene.dataset.animTime = time.toFixed(3);
      }

      /* ── Ablaufsteuerung ────────────────────────────────────────────────── */

      let raf = 0, startedAt = 0, elapsed = 0, running = false, finished = false;
      const reduced = window.matchMedia("(prefers-reduced-motion: reduce)");

      function frame(now) {
        if (!running) return;
        elapsed = (now - startedAt) / 1000;
        render(elapsed);
        if (elapsed < T_END) { raf = requestAnimationFrame(frame); return; }
        stop(true);
      }

      function stop(done) {
        running = false;
        if (raf) cancelAnimationFrame(raf);
        raf = 0;
        if (done) {
          finished = true;
          elapsed = T_END;
          render(T_END);
          body.dataset.anim = "done";
        }
      }

      function play() {
        if (running) return;
        finished = false;
        body.dataset.anim = "running";
        // Statische Zustandsschalter treten während der Sequenz zurück.
        body.dataset.state = "day";
        $$("[data-state-btn]").forEach((b) => b.classList.toggle("is-on", b.dataset.stateBtn === "day"));

        elapsed = 0;
        render(0);
        startedAt = performance.now();
        running = true;
        raf = requestAnimationFrame(frame);
      }

      function reset() {
        stop(false);
        finished = false;
        elapsed = 0;
        body.dataset.anim = "idle";
        scene.style.removeProperty("--night");
        lampEls().forEach((el) => el.style.removeProperty("--lamp"));
        const out = $("[data-anim-readout]");
        if (out) out.textContent = "—";
      }

      /* ── Pausieren, wenn niemand zusieht ────────────────────────────────── */

      function pause() {
        if (!running) return;
        running = false;
        if (raf) cancelAnimationFrame(raf);
        raf = 0;
      }
      function resume() {
        if (running || finished || body.dataset.anim !== "running") return;
        startedAt = performance.now() - elapsed * 1000;
        running = true;
        raf = requestAnimationFrame(frame);
      }

      document.addEventListener("visibilitychange", () => {
        if (document.hidden) pause(); else resume();
      });

      if ("IntersectionObserver" in window) {
        new IntersectionObserver((entries) => {
          for (const e of entries) {
            if (e.isIntersecting) resume(); else pause();
          }
        }, { threshold: 0.15 }).observe(scene);
      }

      /* ── Bedienung ──────────────────────────────────────────────────────── */

      /* Einzelne Masten lassen sich auch während der Sequenz zuschalten. */

      /* ── Standbild eines Zeitpunkts über die URL ────────────────────────
         ?t=3.2 zeigt genau diesen Moment, ohne Bewegung. Für Prüfbilder.   */
      window.MaisonBatuPhaseC = Object.freeze({
        duration: T_END,
        nightWindow: [NIGHT_FROM, NIGHT_TO],
        ignition: IGNITION,
        render, play, reset,
      });
    })();


    /* ══════════════════════════════════════════════════════════════════════════
       Maison Batu — Phase III · Phase D
       Der Tennisball: genau drei Bodenkontakte, danach verlässt er das Bild
       unter der unteren Clipkante — deckend, ohne Ausblenden, ohne Versinken.

       Der Ball ist absolut im Bildfeld positioniert und wird ausschließlich über
       `transform` bewegt. Er kann das Layout deshalb nicht verschieben, und die
       untere Kante schneidet ihn durch `overflow: hidden` des Bildfelds sauber ab.
       ══════════════════════════════════════════════════════════════════════════ */
    (() => {
      "use strict";

      const body = root;
      const $  = (s, r = root) => r.querySelector(s);
      const $$ = (s, r = root) => Array.from(r.querySelectorAll(s));
      const scene = $(".mbe-window");
      const ball = $("img[data-ball]");
      const shadow = $("[data-ball-shadow]");
      if (!scene || !ball || !shadow) return;

      /* ── Bahn ───────────────────────────────────────────────────────────────
         Alle Werte sind Anteile der Bildfeldbreite beziehungsweise -höhe, damit
         die Bahn in jedem Viewport gleich sitzt.

         Die Bahn läuft rechts an den drei Karten vorbei (deren rechte Kante liegt
         bei 68,6 %), damit der Ball zu keinem Zeitpunkt dahinter verschwindet.
         Die Kontaktpunkte liegen auf dem Platz und wandern zur Kamera hin —
         entsprechend wächst der Ball von Kontakt zu Kontakt.                   */

      const LANES = {
        desktop: {
          d: 0.052,                                  // Balldurchmesser, Anteil der Breite
          x: [0.688, 0.706, 0.729, 0.757, 0.796],    // Eintritt, K1, K2, K3, Austritt
          ground: [0.660, 0.752, 0.858, 1.180],      // Bodenhöhe bei K1, K2, K3, Austritt
          scale: [0.46, 0.62, 0.80, 1.00, 1.62],
          apex: [0.150, 0.074, 0.030],               // Sprunghöhen, deutlich abnehmend
        },
        mobile: {
          d: 0.115,
          x: [0.300, 0.330, 0.386, 0.462, 0.560],
          ground: [0.474, 0.536, 0.605, 1.180],
          scale: [0.44, 0.60, 0.78, 1.00, 1.55],
          apex: [0.104, 0.052, 0.021],
        },
      };

      /* ── Zeitplan ───────────────────────────────────────────────────────────
         Die Abstände zwischen den Kontakten werden kürzer (0,78 → 0,56 s), die
         Sprunghöhen entsprechend kleiner — beides folgt demselben Stoßfaktor. */

      const T_IN  = 0.00;   // Ball noch über dem Bild
      const T_C1  = 0.86;   // erster Bodenkontakt
      const T_C2  = 1.64;   // zweiter
      const T_C3  = 2.20;   // dritter
      const T_OUT = 3.05;   // unter der unteren Clipkante verschwunden
      const T_END = 3.45;

      const clamp01 = (v) => (v < 0 ? 0 : v > 1 ? 1 : v);
      const smooth = (v) => { const x = clamp01(v); return x * x * (3 - 2 * x); };
      const mix = (a, b, t) => a + (b - a) * t;
      const seg = (t, a, b) => clamp01((t - a) / (b - a));

      const lane = () => LANES[body.dataset.frame] || LANES.desktop;

      /* Wurfparabel: 0 am Anfang und Ende, 1 im Scheitel. */
      const arc = (u) => 4 * u * (1 - u);

      function sample(t) {
        const L = lane();
        let phase, u, groundFrom, groundTo, xa, xb, sa, sb, apex;

        if (t <= T_C1)      { phase = 0; u = seg(t, T_IN, T_C1);  groundFrom = L.ground[0]; groundTo = L.ground[0]; xa = L.x[0]; xb = L.x[1]; sa = L.scale[0]; sb = L.scale[1]; apex = 0; }
        else if (t <= T_C2) { phase = 1; u = seg(t, T_C1, T_C2);  groundFrom = L.ground[0]; groundTo = L.ground[1]; xa = L.x[1]; xb = L.x[2]; sa = L.scale[1]; sb = L.scale[2]; apex = L.apex[0]; }
        else if (t <= T_C3) { phase = 2; u = seg(t, T_C2, T_C3);  groundFrom = L.ground[1]; groundTo = L.ground[2]; xa = L.x[2]; xb = L.x[3]; sa = L.scale[2]; sb = L.scale[3]; apex = L.apex[1]; }
        else                { phase = 3; u = seg(t, T_C3, T_OUT); groundFrom = L.ground[2]; groundTo = L.ground[3]; xa = L.x[3]; xb = L.x[4]; sa = L.scale[3]; sb = L.scale[4]; apex = L.apex[2]; }

        const ground = mix(groundFrom, groundTo, phase === 0 ? 1 : smooth(u));
        const x = mix(xa, xb, phase === 0 ? smooth(u) : u);
        const scale = mix(sa, sb, phase === 0 ? smooth(u) : u);

        let height;         // Höhe über dem Boden, Anteil der Bildfeldhöhe
        let airborne;       // 0 am Boden, 1 im Scheitel — steuert den Schatten
        if (phase === 0) {
          // Anflug von oben: beschleunigter Fall
          const fall = Math.pow(u, 2.2);
          height = mix(0.62, 0, fall);
          airborne = 1 - fall;
        } else {
          height = apex * arc(u);
          airborne = arc(u);
        }

        return { x, ground, height, scale, airborne, phase, u };
      }

      /* ── Darstellung ────────────────────────────────────────────────────── */

      function renderBall(t) {
        const time = Math.max(0, Math.min(T_END, t));
        const W = scene.clientWidth, H = scene.clientHeight;
        if (!W || !H) return;

        const L = lane();
        const s = sample(time);

        const diameter = L.d * W;
        const size = diameter * s.scale;
        const cx = s.x * W;
        const groundY = s.ground * H;
        const cy = groundY - s.height * H - size / 2;

        /* Kurzes Stauchen genau im Moment des Aufpralls. Die Stauchung steht
           bewusst VOR der Drehung im Transform, damit sie in Bildschirmachsen
           wirkt — der Ball drückt sich gegen den Boden, nicht gegen seine
           mitgedrehte Eigenachse. Sonst entsteht eine schiefe Eiform. */
        const impact = [T_C1, T_C2, T_C3].reduce((m, c) => Math.max(m, clamp01(1 - Math.abs(time - c) / 0.055)), 0);
        const sx = 1 + 0.15 * impact;
        const sy = 1 - 0.19 * impact;

        const angle = 300 * time + 40 * Math.sin(time * 2.1);

        ball.style.width = `${size.toFixed(2)}px`;
        ball.style.height = `${size.toFixed(2)}px`;
        ball.style.transform =
          `translate3d(${(cx - size / 2).toFixed(2)}px, ${cy.toFixed(2)}px, 0) scale(${sx.toFixed(4)}, ${sy.toFixed(4)}) rotate(${angle.toFixed(1)}deg)`;

        /* Der Schatten sitzt am Kontaktpunkt, nicht am Ball: er folgt der
           Bodenhöhe und wird mit zunehmender Flughöhe größer und schwächer. */
        const shW = size * (0.98 + 0.62 * s.airborne);
        const shH = shW * 0.30;
        shadow.style.width = `${shW.toFixed(2)}px`;
        shadow.style.height = `${shH.toFixed(2)}px`;
        shadow.style.transform = `translate3d(${(cx - shW / 2).toFixed(2)}px, ${(groundY - shH / 2).toFixed(2)}px, 0)`;
        shadow.style.opacity = (0.46 * (1 - 0.68 * s.airborne)).toFixed(3);

        // Vor dem Eintritt unsichtbar — danach durchgehend deckend.
        const visible = time > 0.02;
        ball.style.visibility = visible ? "visible" : "hidden";
        shadow.style.visibility = visible && s.ground < 1.02 ? "visible" : "hidden";

        scene.dataset.ballTime = time.toFixed(3);
        const out = $("[data-ball-readout]");
        if (out) out.textContent = `${time.toFixed(2)} s · Kontakt ${Math.min(3, s.phase)} von 3`;
      }

      function clear() {
        ball.style.visibility = "hidden";
        shadow.style.visibility = "hidden";
        const out = $("[data-ball-readout]");
        if (out) out.textContent = "—";
      }

      /* ── Ablauf ─────────────────────────────────────────────────────────── */

      let raf = 0, startedAt = 0, elapsed = 0, running = false, finished = false;
      const reduced = window.matchMedia("(prefers-reduced-motion: reduce)");

      function frame(now) {
        if (!running) return;
        elapsed = (now - startedAt) / 1000;
        renderBall(elapsed);
        if (elapsed < T_END) { raf = requestAnimationFrame(frame); return; }
        running = false; finished = true; raf = 0;
        renderBall(T_END);
        body.dataset.ballseq = "done";
      }

      function play() {
        if (running) return;
        finished = false;
        body.dataset.ballseq = "running";
        // Der Ball spielt auf der fertigen Nacht — er kommt in der Erzählung danach.
        if (window.MaisonBatuPhaseC) {
          body.dataset.anim = "done";
          window.MaisonBatuPhaseC.render(window.MaisonBatuPhaseC.duration);
        }
        elapsed = 0;
        renderBall(0);
        startedAt = performance.now();
        running = true;
        raf = requestAnimationFrame(frame);
      }

      function reset() {
        running = false;
        if (raf) cancelAnimationFrame(raf);
        raf = 0; elapsed = 0; finished = false;
        body.dataset.ballseq = "idle";
        clear();
      }

      function pause() { if (!running) return; running = false; if (raf) cancelAnimationFrame(raf); raf = 0; }
      function resume() {
        if (running || finished || body.dataset.ballseq !== "running") return;
        startedAt = performance.now() - elapsed * 1000;
        running = true; raf = requestAnimationFrame(frame);
      }
      document.addEventListener("visibilitychange", () => { document.hidden ? pause() : resume(); });
      if ("IntersectionObserver" in window) {
        new IntersectionObserver((es) => { for (const e of es) e.isIntersecting ? resume() : pause(); },
          { threshold: 0.15 }).observe(scene);
      }
      window.addEventListener("resize", () => {
        if (body.dataset.ballseq === "running" || body.dataset.ballseq === "done") renderBall(elapsed);
      }, { passive: true });

      /* Standbild eines Zeitpunkts: ?tb=1.64 */
      window.MaisonBatuPhaseD = Object.freeze({
        duration: T_END,
        contacts: [T_C1, T_C2, T_C3],
        exit: T_OUT,
        sample, render: renderBall, play, reset,
      });
    })();


    /* ══════════════════════════════════════════════════════════════════════════
       Maison Batu — Phase III · Phase E
       Die Gesamtsequenz: Lampen und Ball auf einer gemeinsamen Zeitachse,
       rund sieben Sekunden, einmalig. Danach bleibt die Nacht ruhig stehen.

       Dieses Modul rechnet nichts neu. Es treibt ausschließlich die beiden
       bereits freigegebenen Sequenzen aus einer einzigen Uhr — deshalb ist der
       Endzustand zwangsläufig derselbe wie in Phase C und D.
       ══════════════════════════════════════════════════════════════════════════ */
    (() => {
      "use strict";

      const body = root;
      const $  = (s, r = root) => r.querySelector(s);
      const $$ = (s, r = root) => Array.from(r.querySelectorAll(s));
      const scene = $(".mbe-window");
      const C = window.MaisonBatuPhaseC;
      const D = window.MaisonBatuPhaseD;
      if (!scene || !C || !D) return;

      /* Der Ball setzt ein, während die beiden hinteren Masten noch hochlaufen.
         Damit greifen die beiden Sequenzen ineinander, statt aneinandergereiht
         zu wirken — und die Gesamtdauer bleibt bei rund sieben Sekunden. */
      const BALL_AT = 3.60;
      const T_END = BALL_AT + D.duration;          // 7,05 s
      const pacing = Math.max(10, Math.min(18, Number(root.dataset.autoplayDuration) || 12));
      /* Das frühere Theme-Feld hatte 12 als gespeicherten Normalwert. V4 ist
         bei diesem Normalwert exakt 7,05 s lang; andere Werte verändern das
         Tempo proportional, ohne den freigegebenen Ablauf zu verschieben. */
      const PLAYBACK_END = T_END * pacing / 12;

      function render(t) {
        const time = Math.max(0, Math.min(T_END, t));
        C.render(Math.min(time, C.duration));
        D.render(time - BALL_AT);                  // negativ → Ball bleibt verborgen
        scene.dataset.seqTime = time.toFixed(3);
        /* data-seq-time wird am Bildfeld selbst gespeichert. Ein optionales
           Debug-Readout muss deshalb einen eigenen Attributnamen tragen. */
        const out = $("[data-seq-readout]");
        if (out) out.textContent = `${time.toFixed(2)} s / ${T_END.toFixed(2)} s`;
      }

      let raf = 0, startedAt = 0, elapsed = 0, running = false, finished = false;
      const reduced = window.matchMedia("(prefers-reduced-motion: reduce)");

      function frame(now) {
        if (!running) return;
        elapsed = (now - startedAt) / 1000;
        render(elapsed / PLAYBACK_END * T_END);
        if (elapsed < PLAYBACK_END) { raf = requestAnimationFrame(frame); return; }
        running = false; finished = true; raf = 0;
        render(T_END);
        body.dataset.seq = "done";                 // die Nacht bleibt stehen
      }

      function play() {
        if (running) return;
        finished = false;
        /* Eigene Zustände: die Einzelsequenzen erkennen daran, dass sie nicht
           selbst laufen, und mischen sich nicht ein. */
        body.dataset.seq = "running";
        body.dataset.anim = "seq";
        body.dataset.ballseq = "seq";
        body.dataset.state = "day";
        $$("[data-state-btn]").forEach((b) => b.classList.toggle("is-on", b.dataset.stateBtn === "day"));

        /* Das bestehende Maison-Batu-Theme meldet auf manchen Android-
           Geräten reduced motion, obwohl der Besucher die Phase-Animation
           ausdrücklich erwartet. Wie bei Phase II steuert deshalb nur der
           Shopify-Schalter data-mbe-autoplay den statischen Endzustand. */
        elapsed = 0;
        render(0);
        startedAt = performance.now();
        running = true;
        raf = requestAnimationFrame(frame);
      }

      function reset() {
        running = false;
        if (raf) cancelAnimationFrame(raf);
        raf = 0; elapsed = 0; finished = false;
        body.dataset.seq = "idle";
        body.dataset.anim = "idle";
        body.dataset.ballseq = "idle";
        C.reset(); D.reset();
        const out = $("[data-seq-readout]");
        if (out) out.textContent = "—";
      }

      function pause() { if (!running) return; running = false; if (raf) cancelAnimationFrame(raf); raf = 0; }
      function resume() {
        if (running || finished || body.dataset.seq !== "running") return;
        startedAt = performance.now() - elapsed * 1000;
        running = true; raf = requestAnimationFrame(frame);
      }
      document.addEventListener("visibilitychange", () => { document.hidden ? pause() : resume(); });
      if ("IntersectionObserver" in window) {
        new IntersectionObserver((es) => { for (const e of es) e.isIntersecting ? resume() : pause(); },
          { threshold: 0.15 }).observe(scene);
      }
      window.addEventListener("resize", () => {
        if (body.dataset.seq === "running" || body.dataset.seq === "done") {
          render(body.dataset.seq === "done" ? T_END : elapsed);
        }
      }, { passive: true });

  
      window.MaisonBatuPhaseE = Object.freeze({
        duration: T_END,
        playbackDuration: PLAYBACK_END,
        ballAt: BALL_AT,
        render,
        play,
        reset,
      });
    })();


    /* Produktionsverhalten: einmal abspielen, sobald die Section sichtbar
       wird. Danach bleibt die Nacht stehen. */
    const E = window.MaisonBatuPhaseE;
    if (!E) return;
    const reduceRequested = root.dataset.respectReducedMotion === "true"
      && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (root.dataset.mbeAutoplay === "0" || reduceRequested) {
      root.dataset.anim = "done";
      root.dataset.ballseq = "done";
      root.dataset.seq = "done";
      E.render(E.duration);
    } else {
      const replayOnEntry = root.dataset.replayOnEntry === "true";
      let started = false;
      const kick = () => { if (started) return; started = true; E.play(); };
      if ("IntersectionObserver" in window) {
        const io = new IntersectionObserver((es) => {
          for (const e of es) {
            if (e.isIntersecting) {
              kick();
              if (!replayOnEntry) io.disconnect();
            } else if (replayOnEntry && root.dataset.seq === "done") {
              E.reset();
              started = false;
            }
          }
        }, { threshold: 0.35 });
        io.observe(root);
      } else { kick(); }
    }

    /* Shopify reloads the page after a customer-form submission. Preserve the
       visitor's waitlist position exactly as Phase II does, instead of
       returning above the footer result message. */
    const waitlistStorageKey = `maisonBatuEmergenceWaitlistScroll:${root.id}`;
    const restoreWaitlistPosition = () => {
      const params = new URLSearchParams(window.location.search);
      const wasCustomerSubmit = params.has("customer_posted")
        || window.location.href.includes("customer_posted=true");
      if (!wasCustomerSubmit) return;

      try {
        const stored = JSON.parse(sessionStorage.getItem(waitlistStorageKey) || "{}");
        if (stored.path !== window.location.pathname || stored.section !== root.id || typeof stored.y !== "number") return;
        if (window.location.hash) {
          history.replaceState(history.state, "", `${window.location.pathname}${window.location.search}`);
        }
        window.requestAnimationFrame(() => {
          window.scrollTo({ top: stored.y, behavior: "auto" });
          sessionStorage.removeItem(waitlistStorageKey);
        });
      } catch (error) {
        sessionStorage.removeItem(waitlistStorageKey);
      }
    };

    root.querySelectorAll(".mbe-waitlist__form").forEach((form) => {
      form.addEventListener("submit", () => {
        try {
          sessionStorage.setItem(waitlistStorageKey, JSON.stringify({
            path: window.location.pathname,
            section: root.id,
            y: window.scrollY,
          }));
        } catch (error) {}
      });
    });
    restoreWaitlistPosition();
  }
})();
